import Glide from '@glidejs/glide'

const glideOptions = {
  type: 'carousel',
  gap: 0,
  animationDuration: 1000,
  autoplay: 5000,
  rewindDuration: 2000,
}

for (const elem of document.querySelectorAll('.glide')) {
  const numSlides = elem.querySelectorAll('.glide__slide').length

  if (numSlides > 1) {
    new Glide(elem, glideOptions).mount()
  }
}
